import { render, staticRenderFns } from "./DirectoryTable.vue?vue&type=template&id=8f8dc2b2&"
import script from "./DirectoryTable.vue?vue&type=script&lang=js&"
export * from "./DirectoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports